
import auth from './AuthAPI.js'
import * as APPCONFIG from '../config/app-config.js'
import Http from './Http.js';

class EquipmentApi {
  
    saveEquipment(form) {
        return auth({
          method: "post",
          headers: Http.MULTIPART_HEADERS(),
          url: `${APPCONFIG.API_URL}api/saveEquipmentV2`,
          data: form,
        });
      }   

   
      editEquipment(form) {
        return auth({
            method: "post",
            headers: Http.MULTIPART_HEADERS(),
            url: `${APPCONFIG.API_URL}api/editEquipmentV2`,
            data: form,
          });
      }

      
       
      getEquipmentList(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/getEquipmentList`,
            data: JSON.stringify(form),
          });
      }

      deleteEquipment(form) {
        return auth({
            method: "post",
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/deleteEquipment`,
            data: JSON.stringify(form),
          });
      }



      // ------------------------services Records-------------------

      saveServiceRecord(form) {
        return auth({
            method: "post",
            headers: Http.MULTIPART_HEADERS(),
            url: `${APPCONFIG.API_URL}api/saveServiceRecord`,
            data: form,
          });
      }

      getdataByResource(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/getdataByResource`,
          data: JSON.stringify(form),
        });
      }

    
      editServiceRecord(form) {
        return auth({
            method: "post",
            headers: Http.MULTIPART_HEADERS(),
            url: `${APPCONFIG.API_URL}api/editServiceRecord`,
            data: form,
          });
      }
      
      deleteServiceRecord(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/deleteServiceRecord`,
          data: JSON.stringify(form),
        });
      }

      togetFullDataByServiceTypeandResourceId(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/togetFullDataByServiceTypeandResourceId`,
          data: JSON.stringify(form),
        });
      }


      togetFullDataByServiceTypeandResourceIdNotification(form){
        return auth({
          method: "post",
          headers: Http.AUTH_HEADERS(),
          url: `${APPCONFIG.API_URL}api/togetFullDataByServiceTypeandResourceIdNotification`,
          data: JSON.stringify(form),
        });
      }

}

export default new EquipmentApi();